module.exports = __webpack_public_path__ + "img/goods3_2.1d8fbb5f.jpg";